import { isBefore, addDays } from 'date-fns';
import { format } from 'date-fns';

export const formatTime = (time, timeFormat = "yyyy-MM-dd'T'HH:mm:ssX") => format(time, timeFormat);
export const formatDate = (time, timeFormat = 'yyyy-MM-dd') => format(time, timeFormat);
export const presentDateTime = (time, timeFormat = 'yyyy-MM-dd HH:mm:ssX') => format(time, timeFormat);
export const checkDateRange = (start, end, range) => isBefore(addDays(start, range), end);

export function getNullDate(s) {
	if (!s) return null;
	return new Date(s);
}
